import React from 'react';
import { SubscriptionStatus } from '../../shared/Constants';
import ActiveSubscriptionActionButtons from './ActiveSubscriptionActionButtons';
import { Button } from 'primereact/button';

const SubscriptionActionButtons = ({
  redirectToChangeSubscriptionPage,
  redirectToStopSubscriptionPage,
  managingAccountId,
  clientAccountId,
  status,
  renewSubscription,
  redirectToBuySubscriptionPage,
}) => {
  if (status === SubscriptionStatus.ACTIVE || status === SubscriptionStatus.TRIALING) {
    return (
      <ActiveSubscriptionActionButtons
        redirectToChangeSubscriptionPage={redirectToChangeSubscriptionPage}
        redirectToStopSubscriptionPage={redirectToStopSubscriptionPage}
        managingAccountId={managingAccountId}
        clientAccountId={clientAccountId}
      />
    );
  }

  if (status === SubscriptionStatus.PAUSED) {
    return <Button type="button" label="Renew" onClick={renewSubscription} />;
  }

  if (status === SubscriptionStatus.PAST_DUE) {
    return <p>The payment for this subscription failed! Please check your credit card information!</p>;
  }

  if (status === SubscriptionStatus.CANCELED) {
    return <Button type="button" label="Pay now" onClick={redirectToBuySubscriptionPage} />;
  }

  return <Button type="button" label="Pay now" onClick={redirectToBuySubscriptionPage} />;
};

export default SubscriptionActionButtons;
